import {ADD_RESULTS, SET_PAGE} from "~/actions/jobs";
import config from "~/config";

const INITIAL_STATE = {
    all: {},
    order: [],
    page: 0,
    pageSize: config("ui.filterJobsDemoMode", false) ? 40 : 20,
    count: null,
    isFetching: false,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ADD_RESULTS:
            return addResults(state, action.count, action.jobs);

        case SET_PAGE:
            return setPage(state, action.page);

        default:
            return state;
    }
}

function addResults(state, count, jobs) {
    const nextAll = {...state.all};
    const nextOrder = [];

    for (const job of jobs) {
        nextAll[job.id] = job;

        if (!nextOrder.includes(job.id)) {
            nextOrder.push(job.id);
        }
    }

    return {
        ...state,
        all: nextAll,
        order: nextOrder,
        count,
    };
}

function setPage(state, page) {
    return {...state, page};
}
